'use client';

export { default } from './Hidden';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Hidden/index.js
// module id = 852
// module chunks = 22